import {useStyles} from '../../shared/hooks/styles';
import {DeviceSize} from '../../shared/theme/helpers';

export default () =>
  useStyles(({theme, mediaOnly, mediaExclude}) => ({
    contentContainer: {
      flexDirection: 'row',
      justifyContent: 'center',
    },
    sectionContainer: {
      marginTop: 24,
      paddingHorizontal: 24,
      marginBottom: theme.screen.bottomOffset,
      flexGrow: 1,
      flexShrink: 1,
    },
    titleContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 40,
    },
    sectionTitle: {...theme.fonts.h2},
    noData: {
      ...mediaOnly(DeviceSize.desktop, theme.fonts.h5Light, theme.fonts.bodySmallLight),
      ...mediaExclude(DeviceSize.desktop, {textAlign: 'center'}),
      color: theme.privilegeNoData.color,
    },
    loadMoreWrapper: {
      marginTop: 30,
      flexDirection: 'row',
      ...mediaExclude(
        DeviceSize.desktop,
        {flexDirection: 'column', alignItems: 'center'},
        {flexDirection: 'row', justifyContent: 'space-between'},
      ),
    },
    allToReadMobileContainer: {
      alignItems: 'center',
    },
    allToReadButton: {
      ...mediaExclude(DeviceSize.desktop, {width: '100%', marginBottom: 24}, {width: 230}),
    },
    loadMoreButton: {
      ...mediaExclude(DeviceSize.desktop, {width: 290}, {width: 230}),
    },
  }));
